export default {
    pesans: [],
    pesansAll: [],
    notif: {
        msg: null,
        type: null
    },
    sql: null,
    overlay: true,
    overlay_bg: null,
    anchor: null,
    dalam_mutasi: null,
    dalam_keluar: null,
    kunci_penginputan: false,
    dinasUmum: null,
    sideNav: false,
    main_tenis: false,
    devMode: false,
    app_info: null
}